export default __webpack_public_path__ + "static/blobedFeature-59d0334b9036e89f33d77fe342e4c278.png";